@let view = view$ | async;

@if (view !== EngagementHubView.DETAIL) {
  <app-engagement-landing
    class="landing-content"
    [isUsingSecureLink]="isUsingSecureLink()"
    [secureLinkReassignmentView]="view === EngagementHubView.REASSIGNMENT"
    (advance)="onAdvance($event)"
  />
}

@if (detailInitialized()) {
  <app-view-engagement-container
    [class.d-none]="view !== EngagementHubView.DETAIL"
    class="w-100 h-100"
    [isUsingSecureLink]="isUsingSecureLink()"
    [onNavigateToNextEntity]="onNavigateToNextEntity()"
    [onNavigateToPreviousEntity]="onNavigateToPreviousEntity()"
    [showSideDrawer]="showSideDrawer()"
    (engagementHubView)="engagementHubView.emit($event)"
    (sideDrawerOpened)="sideDrawerOpened.emit($event)"
  />
}
